import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { store } from './store/store'
import App from './App'
import reportWebVitals from './reportWebVitals'
import PersistProvider from './store/providers/persist-provider'
import 'swiper/css'
import 'swiper/css/pagination'

import './i18n'
import './assets/scss/print-styles.css'
import './assets/scss/style.scss'
import dayjs from 'dayjs';
import zhTW from "antd/lib/locale/zh_TW";
import { ConfigProvider } from 'antd'
import { GoogleOAuthProvider } from '@react-oauth/google'
import 'smart-webcomponents-react/source/styles/smart.default.css';

import { suppressResizeObserverError } from '@utils/suppressResizeObserverError'

// 攔截並隱藏開發環境中 AntD Select / DatePicker 展開時可能觸發的 ResizeObserver 警告
suppressResizeObserverError()

dayjs.locale('zh-tw');

const root = ReactDOM.createRoot(document.getElementById('root'))


const googleClientId = (process.env.REACT_APP_GOOGLE_CLIENT_ID || "").trim()

const appShell = (
  <PersistProvider>
    <ConfigProvider
      locale={zhTW}
      theme={{
        token: {
          colorPrimary: "#513f24", // 設置主色
        },
      }}
    >
      <App />
    </ConfigProvider>
  </PersistProvider>
)


root.render(
  <Provider store={store}>
    {googleClientId ? (
      <GoogleOAuthProvider clientId={googleClientId}>
        {appShell}
      </GoogleOAuthProvider>
    ) : (
      appShell
    )}
  </Provider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
